import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import './styles.scss'

const PhoneNumber = ({ number, variant, size }) => (
  <div
    className={cx({
      'phone-number': true,
      [`phone-number--${variant}`]: variant,
      [`phone-number--${size}`]: size
    })}
  >
    {number}
  </div>
)

PhoneNumber.propTypes = {
  number: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'highlighted', 'neutral']),
  size: PropTypes.oneOf(['small', 'large'])
}

PhoneNumber.defaultProps = {
  variant: 'default',
  size: 'large'
}

export default PhoneNumber
